module.exports = __webpack_public_path__ + "img/recharge.0a13eac0.png";